import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';
import ProductCard from '../components/shared/ProductCard';

export default function SellerProfile() {
  const { id } = useParams();
  const [seller, setSeller] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSeller = async () => {
      try {
        const res = await api.get(`/products/seller/${id}`);
        setSeller(res.data.seller);
        setProducts(res.data.products);
      } catch (err) {
        console.error('Failed to fetch seller profile', err);
      }
      setLoading(false);
    };
    fetchSeller();
  }, [id]);

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-lux-gold border-t-transparent rounded-full animate-spin" />
    </div>
  );

  if (!seller) return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="font-display text-2xl text-gray-400 italic">Seller not found.</p>
    </div>
  );

  const displayName = seller.storeName || `${seller.firstName} ${seller.lastName}`;

  return (
    <div className="animate-fade-in">
      {/* Seller Header */}
      <div className="bg-lux-primary text-white py-16 px-6 md:px-12 lg:px-20">
        <div className="max-w-7xl mx-auto">
          <p className="text-[10px] uppercase tracking-[0.5em] text-lux-gold mb-4">Seller Profile</p>
          <h1 className="font-display text-4xl md:text-6xl font-light tracking-tighter mb-3">{displayName}</h1>
          <p className="text-sm text-white/50 font-sans">
            {seller.firstName} {seller.lastName} · Member since {new Date(seller.memberSince).toLocaleDateString('en-IN', { year: 'numeric', month: 'long' })}
          </p>
          <p className="text-[11px] uppercase tracking-[0.2em] text-white/40 mt-4">
            {products.length} {products.length === 1 ? 'Product' : 'Products'} Listed
          </p>
        </div>
      </div>

      {/* Products */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-16">
        <h2 className="font-display text-2xl text-lux-primary mb-10">All Products</h2>
        {products.length === 0 ? (
          <div className="text-center py-20 bg-gray-50">
            <p className="font-display text-xl text-gray-400 italic">No products listed yet.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-8 gap-y-16">
            {products.map(p => <ProductCard key={p._id} product={p} />)}
          </div>
        )}
      </div>
    </div>
  );
}
